import { render } from "./user.vue?vue&type=template&id=f5c293c2&scoped=true"
import script from "./user.vue?vue&type=script&lang=js"
export * from "./user.vue?vue&type=script&lang=js"

import "./user.vue?vue&type=style&index=0&id=f5c293c2&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5c293c2"]])

export default __exports__